import ErrorIcon from "@mui/icons-material/Error";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function ErrorBoundaryFallback() {
  return (
    <Box
      sx={{
        position: "fixed",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)"
      }}
    >
      <Typography
        variant="h1"
        color="primary"
        sx={{ display: "flex", alignItems: "center" }}
      >
        <ErrorIcon sx={{ mr: 2 }} fontSize="inherit" /> We have a new version!
      </Typography>
      <Typography variant="h5">
        To resolve this, please try refreshing the page. This will reload the
        updated version and restore normal functionality.
      </Typography>
    </Box>
  );
}
